import classNames from 'classnames';
import React from 'react';

interface Props {
  title?: string;
  subtitle?: string;
  items?: (string | string[])[];
  sublist?: boolean;
  extra?: string;
}

function List({ title, subtitle, items, sublist, extra = '' }: Props) {
  if ((!items || items.length === 0) && !extra) return null;

  return (
    <div className={classNames(sublist ? 'ml-6' : '', 'flex flex-col mb-4')}>
      {title && (
        <div className="mb-4">
          <h4 className="font-primarybold text-md text-black">{title}</h4>
        </div>
      )}
      {subtitle && (
        <h5
          className={classNames(
            sublist ? 'text-xs' : 'text-sm',
            'text-left font-primarybold text-textgrey mb-2',
          )}
        >
          {subtitle}
        </h5>
      )}
      <ul className="list-disc list-inside text-xs">
        {(Array.isArray(items) ? items : []).map((item, index) => {
          if (Array.isArray(item) && item.length > 0) {
            return (
              <li key={index}>
                {/* Titolo principale */}
                <span className="text-xs font-primarybold">
                  {item[0]}
                </span>
                {/* Sotto-lista */}
                <ul className="list-circle list-inside ml-6 mt-1">
                  {item.slice(1).map((sub, subIdx) => (
                    <li key={subIdx} className="text-xs">
                      {sub}
                    </li>
                  ))}
                </ul>
              </li>
            );
          }

          return (
            <li key={index}>
              <span className="text-xs">{item}</span>
            </li>
          );
        })}
        {extra && <li className="text-xs">Altro: {extra}</li>}
      </ul>
    </div>
  );
}

List.defaultProps = {
  title: '',
  subtitle: '',
  items: [],
  sublist: false,
};

export default List;
